import React, { useState } from "react";
import { Link } from "react-router-dom";
import Text from "../../common/Text";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { cancelSubscriptionPlan } from "../../../states/actions/fetchDashSubscription";
import FormProcessingSpinner from "../../common/FormProcessingSpinner";
import { eventDateFormat } from "../../../helpers/helpers";

const SubscriptionManage = ({ content, subscribeArr, plan }) => {
  // console.log("subscribeArr", subscribeArr);

  const dispatch = useDispatch();
  const CANCEL_PLAN_REASONS = [
    "I have found a job",
    "I could not find what I was looking for",
    "I subscribed only temporarily",
    "I am not looking for a job in the UK anymore",
    "I could find the same content elsewhere",
    "It is too expensive for me",
  ];

  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const firstSubmit = (data) => {
    dispatch(cancelSubscriptionPlan(data));
  };

  const [popupCancle, setPopupCancle] = useState(false);
  const PopupCancleActive = () => {
    setPopupCancle(!popupCancle);
  };

  const isCancelFormProcessing = useSelector(
    (state) => state.fetchDashSubscription.isCancelFormProcessing
  );

  return (
    <>
      <div className="top_head mb-3">
        <h4 className="heading_dash">
          <Text string={content.banner_heading} />
        </h4>
      </div>

      <div className="top_bar mini_text_blk">
        {subscribeArr ? (
          <>
            <div className="txt">
              <h3 className="color">{plan.plan_name} Subscription</h3>

              {/* {subscribeArr.status === "0" ? (
                <p>Your subscription has been cancelled.</p>
              ) : (
                <>
                  <p>{`Your subscription started on ${eventDateFormat(
                    subscribeArr.start_date
                  )}. You'll be charged £${subscribeArr.price} every ${
                    plan.plan_interval
                  }.`}</p>
                  <p>{`Your next renewal date is ${eventDateFormat(
                    subscribeArr.end_date
                  )}.`}</p>
                  <p>{`Your subscription expiry date is ${eventDateFormat(
                    subscribeArr.end_date
                  )}.`}</p>
                </>
              )} */}

              {subscribeArr.is_cancelled === "1" &&
              (subscribeArr.status === "1" || subscribeArr.status === "0") ? (
                <>
                  <p>
                    <strong>Start Date:</strong>{" "}
                    {eventDateFormat(subscribeArr.start_date)}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    <span className="badge bg-danger">Cancelled</span>
                  </p>
                  <p>
                    <strong>Expiry Date:</strong>{" "}
                    {eventDateFormat(subscribeArr.end_date)}
                  </p>
                  <p>
                    Your subscription has been cancelled. You will retain full
                    access until the expiry date above. No further payments will
                    be taken.
                  </p>
                </>
              ) 
              : subscribeArr.is_cancelled === "1" &&
                subscribeArr.status == "3" ? (
                <>
                  <p>
                    <strong>Start Date:</strong>{" "}
                    {eventDateFormat(subscribeArr.start_date)}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    <span className="badge bg-primary">Refunded</span>
                  </p>
                  <p>
                    <strong>Expiry Date:</strong>{" "}
                    {eventDateFormat(subscribeArr.end_date)}
                  </p>
                  <p>Your subscription payment has been Refunded.</p>
                </>
              ) : (
                <>
                  <p>
                    <strong>Start Date:</strong>{" "}
                    {eventDateFormat(subscribeArr.start_date)}
                  </p>
                  <p>
                    <strong>Next Payment Date:</strong>{" "}
                    {eventDateFormat(subscribeArr.end_date)}
                  </p>
                  <p>
                    <strong>Billing Amount:</strong>{" "}
                    {plan.plan_interval === "monthly" ? (
                      <>£{subscribeArr.price} (billed monthly)</>
                    ) : plan.plan_interval === "biannually" ? (
                      <>
                        £{subscribeArr.price} (£{plan.price_per_month}/month,
                        billed biannually)
                      </>
                    ) : (
                      <>£{subscribeArr.price}</>
                    )}
                  </p>

                  {/* <p>
                    <strong>Billing Amount:</strong> £{subscribeArr.price} per{" "}
                    {plan.plan_interval}
                  </p> */}
                  <p>
                    <strong>Status:</strong>{" "}
                    <span className="badge bg-success">Active</span>
                  </p>
                </>
              )}
            </div>

            {subscribeArr.is_cancelled !== "1" && (
              <div className="btn_blk flex-md-nowrap ms-md-5">
                <Link
                  to="/subscription-offers"
                  className="site_btn long"
                  style={{ display: "none" }}
                >
                  Upgrade
                </Link>
                <div
                  className="site_btn long light"
                  onClick={() => PopupCancleActive()}
                >
                  Cancel
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="txt">
            <p>Details of your subscribed plan will be shown here.</p>
          </div>
        )}
      </div>

      <div
        className={
          popupCancle && subscribeArr
            ? "popup text_popup active"
            : "popup text_popup"
        }
      >
        <div className="table_dv">
          <div className="table_cell">
            <div className="contain">
              <div className="_inner">
                <button
                  type="button"
                  className="x_btn"
                  onClick={() => PopupCancleActive()}
                ></button>
                <div className="heading_text">
                  <h4>Select a reason for cancellation.</h4>
                </div>
                <form
                  action=""
                  method="POST"
                  onSubmit={handleSubmit(firstSubmit)}
                >
                  <div className="form_row row">
                    {CANCEL_PLAN_REASONS &&
                      CANCEL_PLAN_REASONS.map((value, index) => (
                        <div className="col-sm-12">
                          <div className="lbl_btn">
                            <input
                              type="radio"
                              id={value}
                              {...register("reason", {
                                required: "Please select a reason.",
                              })}
                              value={value}
                            />
                            <label htmlFor={value}>{value}</label>
                          </div>
                        </div>
                      ))}
                  </div>
                  <span className="validation-error">
                    {errors.reason?.message}
                  </span>
                  <div className="br"></div>
                  <div className="btn_blk text-center">
                    <button
                      className="site_btn"
                      type="submit"
                      disabled={isCancelFormProcessing}
                    >
                      Submit
                      <FormProcessingSpinner
                        isFormProcessing={isCancelFormProcessing}
                      />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionManage;
